module.exports = __webpack_public_path__ + "static/media/Procontrol_3-min.02d75886.jpg";